export { default } from './ScoredTableSkeleton'
